module.exports = __webpack_public_path__ + "img/GAME_PIANO1.dd8cb0f6.jpg";